import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["defaultLanguageSelect", "supportedLanguagesSelect"]

  addDefault() {
    this.selectize.addItem(this.defaultLanguageSelectTarget.value)
  }

  get selectize() {
    return this.supportedLanguagesSelectTarget.selectize
  }
}
